document.addEventListener('click', function (event) {
  const trackedElement = event.target.closest('[data-track-event]');

  if (!trackedElement) return;

  const eventData = {
    event: trackedElement.dataset.trackEvent,
    button_name:
        trackedElement.dataset.trackLabel ||
        trackedElement.textContent.trim(),
    button_location:
        trackedElement.dataset.trackLocation || 'unknown',
    product_id:
        trackedElement.dataset.productId || null,
    product_name:
        trackedElement.dataset.productTitle || null,
    product_sku:
        trackedElement.dataset.productSku || null,
    page_path: window.location.pathname
    };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventData);
});